import environment from '@square/environment-utils/environment';
import { addBreadcrumb, Severity } from '@sentry/browser';
const env = environment();
const isEnabled = !env.isProduction && !env.isHeadless;
const isSentryLoggingEnabled = env.isStaging || env.isProduction;
const isSentryStateLoggingEnabled = env.isStaging;
/* eslint-disable no-console */
export const updateLogger = workflowName => ([[before, after], action]) => {
  if (isEnabled) {
    console.groupCollapsed(`%c${workflowName} Workflow Update:`, 'font-weight: bold; color: orange;', action.type);
    console.log('%c \u2B07 previous state', 'color: Crimson', before);
    console.log('%c \u2B07 emitted action', 'color: DodgerBlue', action);
    console.log('%c \u2B95 resulting state', 'color: ForestGreen', after);
    console.groupEnd();
  }
};
/* eslint-enable no-console */

export const sentryUpdateLogger = workflowName => ([[before, after], action]) => {
  const data = {
    before,
    action,
    after
  };
  if (isSentryLoggingEnabled) {
    addBreadcrumb({
      level: Severity.Info,
      category: 'workflow',
      message: `${workflowName} Workflow Update: ${action.type}`,
      data: isSentryStateLoggingEnabled ? data : {}
    });
  }
};